import ProfileView from "./ProfileView";
export default ProfileView;